import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import type { IGetPublishHistoryParams, IGetPublishHistoryResponse } from './types';

export const getPublishHistory = async ({
  limit = '15',
  afterId,
  eventType,
  publishedAfter,
  publishedBefore,
  venues,
  priceSchemes,
}: IGetPublishHistoryParams = {}): Promise<IGetPublishHistoryResponse> => {
  try {
    const urlWithParams = new URL(`${API_URL}/publish/publish-history?limit=${limit}`);

    if (afterId) urlWithParams.searchParams.append('after_id', afterId);
    if (eventType) urlWithParams.searchParams.append('event_type', eventType);
    if (publishedAfter) urlWithParams.searchParams.append('published_after', publishedAfter);
    if (publishedBefore) urlWithParams.searchParams.append('published_before', publishedBefore);
    if (venues?.length) urlWithParams.searchParams.append('venues', venues.join(','));
    if (priceSchemes?.length) urlWithParams.searchParams.append('price_schemes', priceSchemes.join(','));

    const response = await fetch(urlWithParams.href);

    if (!response.ok) {
      throw new Error('We have been unable to complete your request. Please try again');
    }

    const json: IGetPublishHistoryResponse = await response.json();
    return json;
  } catch (e) {
    throw e instanceof Error ? e : new Error(String(e));
  }
};
